// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__30QR9","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1vOYk"};